




























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import orderInfo from './components/OrderInfo.vue'
const loginerModule = namespace('loginer')
const SORT_KEY: any = ['goods_num_send', 'goods_num_recipient']
const TRANSFOR_KEY: string = 'bus_date'
const editInputProp = ['goods_num_send', 'goods_price_send', 'sub_total_send']
const sumCol = ['goods_num', 'goods_num_send', 'goods_num_wait_send', 'sub_total_send']
@Component({
	beforeRouteLeave (to: any, from: any, next: any) {
		if ((this as any).isEdit()) {
			(this as any).$fxConfirm('是否保存当前单据？').then(() => {
				(this as any).setTableUnEdit()
				(this as any).onSaveHandler().then(() => {
					this.$message.success('保存成功')
					next()
				})
			}).catch(() => {
				next()
			})
		} else {
			next()
		}
	},
	components: {
		orderInfo
	}
})
export default class RestaurantOrderDetails extends Vue {
	@loginerModule.State('loginerEmail') private loginerEmail?: string
	private orderData: any = {}
	private sendInfo: any = {}
	private orderAttachments: any = []
	private searchKey: string = ''
	private numbers: number = 3
	private isZ5: boolean = false
	private uploadDeliverFlag: boolean = false // 不上传附件不允许发单。undefined: 没有此功能；true: 不上传附件不允许发单；false: 不上传附件允许发单
	private showImgState: boolean = false
	private orderid: string = ''
	private printerVisible: boolean = false
	private get tableData () {
		return this.transforDetails([this.orderData])
	}
	private get tableDataDt () {
		return this.transforDetails(this.orderData.details)
	}
	private get showDt (): boolean {
		return this.orderData.details && this.orderData.details.length !== 0
	}
	private created () {
		this.refreshOrderDetails()
	}
	private mounted () {
		(this as any).$refs.fxTable.doLayout()
	}
	private updated () {
		this.$nextTick(() => {
			(this as any).$refs.fxTable.doLayout()
		})
	}
	private isBillState (state: any) {
		return (this as any).$fxStateMiddleware.stateIs('stateAccount')(state)(this.orderData.bill_state)
	}
	private refreshOrderDetails () {
		return Promise.all([this.getOrderDetails((this as any).$route.query.id)]).then(() => {
			this.getOrderAttachments()
		})
	}
	private onPrintClick (): void {
		const params = (this as any).$route.query.id
		this.orderid = params
		this.printerVisible = true
	}
	private getOrderDetails (id: string): void {
		const params = {
			bill_id: id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/getArapBillAndDt',
			data: params,
			fullData: true
		}).then((res: any) => {
			this.orderData = res.data
			this.isZ5 = res.otherdata === null ? false : res.otherdata.isZ5
			this.numbers = res.otherdata === null ? this.numbers : res.otherdata.number
			this.showImgState = this.uploadDeliverFlag !== undefined && !this.isZ5
			// 获取附件列表
			// if (!(this as any).isZ5 && (this as any).uploadDeliverFlag !== undefined) {
			// 	this.getOrderAttachments()
			// }
		})
	}
	private transforDetails (goodDetails: any = []) {
		return goodDetails
	}
	private sortGoodDetails (goodDetails: any = [], sortKeyFirst: string, sortKeySecond: string) {
		return goodDetails.sort((firstItem: any, secondItem: any) => {
			return (firstItem[sortKeyFirst] - firstItem[sortKeyFirst]) < (secondItem[sortKeySecond] - secondItem[sortKeySecond])
		})
	}
	private onTableRowClick (item: any, colum: any, cell: any, event: any) {
		let property = colum.property
		if (!editInputProp.includes(property)) {
			property = editInputProp[0]
		}
		this.setTableUnEdit().then(() => {
			item.isEdit = true
			this.$nextTick(() => {
				(this.$refs[`grid-${property}`] as any).focus()
			})
		})
	}
	private onCellInputEnter (arg: any, prop: string, index: number) {
		if (!this.isBillState(['tobeDelivered'])) {
			return false
		}
		if (prop === 'next') {
			if (index === this.tableData.length - 1) {
				this.onSaveClick()
				return false
			}
			const row = this.tableData[index + 1]
			this.setTableUnEdit().then(() => {
				this.setTableEdit(row, index + 1)
			})
		} else {
			(this.$refs[`grid-${prop}`] as any).focus()
		}
	}
	private setTableEdit (row: any, index: number) {
		(this as any).$set(this.orderData.details[index], 'isEdit', true)
		this.$nextTick(() => {
			(this.$refs[`grid-${editInputProp[0]}`] as any).focus()
		})
	}
	private setTableUnEdit () {
		this.orderData.details.forEach((item: any, index: number) => {
			(this as any).$set(this.orderData.details[index], 'isEdit', false)
		})
		return Promise.resolve()
	}
	private onCellInputDown (arg: any, prop: string, index: number) {
		if (index === this.tableData.length - 1) {
			return false
		}
		const row = this.tableData[index + 1]
		this.setTableUnEdit().then(() => {
			(this as any).$set(this.orderData.details[index + 1], 'isEdit', true)
			this.$nextTick(() => {
				(this.$refs[`grid-${prop}`] as any).focus()
			})
		})
	}
	private onCellInputUp (arg: any, prop: string, index: number) {
		if (index === 0) {
			return false
		}
		this.setTableUnEdit().then(() => {
			(this as any).$set(this.orderData.details[index - 1], 'isEdit', true)
			this.$nextTick(() => {
				(this.$refs[`grid-${prop}`] as any).focus()
			})
		})
	}
	private onSaveClick () {
		if (!this.isEdit()) {
			return false
		}
		this.setTableUnEdit()
		this.onSaveHandler().then(() => {
			this.$message.success('保存成功')
		})
	}
	private onSaveHandler () {
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateWithDetail',
			data: this.orderData
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onSendClick () {
		(this as any).$fxConfirm('是否确定发货？').then(() => {
			this.checkTableIsEdit().then(this.onSendHandler).then(() => {
				(this as any).$fxMessage.success('发货成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onSendHandler () {
		const params = this.orderData
		params.bill_state = 12
		params.addBatch_flag = false
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateWithDetail',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private isEdit () {
		const editArr = this.tableData.map((item: any) => {
			return item.isEdit
		})
		return editArr.some((item: any) => {
			return !!item
		})
	}
	private checkTableIsEdit () {
		return new Promise((resolve: any) => {
			if (this.isEdit()) {
				this.setTableUnEdit()
				this.onSaveHandler().then(resolve)
			} else {
				resolve()
			}
		})
	}
	private onCancelSendClick () {
		(this as any).$fxConfirm('是否确定取消发货？').then(() => {
			this.onCancelSendHandler().then(() => {
				(this as any).$fxMessage.success('取消发货成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onCancelSendHandler () {
		const params = {
			bill_state: 99,
			id: this.orderData.id,
			plateNumber: this.sendInfo.plateNumber,
			sender: this.sendInfo.sender,
			senderPhone: this.sendInfo.senderPhone,
			sysparameter: this.sendInfo.sysparameter,
			addBatch_flag: false
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onAgreenClick () {
		(this as any).$fxConfirm('是否同意此单据？').then(() => {
			this.onAgreenHandler().then(() => {
				(this as any).$fxMessage.success('同意单据成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onAgreenHandler () {
		const params = {
			bill_state: '1',
			bill_id: this.orderData.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/arapbill_update',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onReturnClick () {
		(this as any).$fxConfirm('是否退回此单据？').then(() => {
			this.onReturnHandler().then(() => {
				(this as any).$fxMessage.success('退回单据成功').then(() => {
					this.$router.go(-1)
				})
			})
		})
	}
	private onReturnHandler () {
		const params = {
			bill_state: '0',
			bill_id: this.orderData.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/arapbill_update',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onSendExcelClick () {
		if (!this.loginerEmail) {
			(this as any).$fxMessage.warning('用户尚未绑定邮箱')
			return false
		}
		(this as any).$fxConfirm('是否确定将单据导出Excel并发送至绑定邮箱？').then(() => {
			this.onSendExcelHandler()
		})
	}
	private onSendExcelHandler () {
		const params = {
			bill_id: (this as any).$route.query.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/8001',
			data: params
		}).then((res: any) => {
			(this as any).$fxMessage.success('邮件发送成功')
		})
	}
	private onExportClick () {
		(this as any).$fxMessage.success('下载成功')
	}
	private getSummaries (param: any) {
		const { columns, data } = param
		return columns.map((item: any, index: number) => {
			if (index === 0) {
				return ''
			} else if (sumCol.includes(item.property)) {
				return (this as any).$fxUtils.arrSum(data, (sumItem: any) => {
					return sumItem[item.property]
				})
			} else {
				return ''
			}
		})
	}
	private getOrderAttachments () {
		const params = {
			id: (this as any).$route.query.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/showEnclosure',
			data: params
		}).then((res: any) => {
			this.orderAttachments = res
			return Promise.resolve()
		})
	}
	private jumpNewPage (scope) {
		this.$router.push({
			path: '/main/restaurantOrdersDetails',
			query: {
				id: scope.up_bill_id
			}
		})
	}
}
